<!--  -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="recommend-tip">
            <span>
                推荐收益:
                <span class="jtgz" @click="showJtgz">具体规则</span>
            </span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <span v-if="mapData.Discount == 0">亲，您暂无推荐折扣，推荐车主用户可享有更多的配件优惠哟！</span>
            <span v-else>根据您目前的推荐量，可享有采购汽配件{{ mapData.Discount }}折优惠</span>
        </div>
        <div class="recommend-main">
            <div class="echart-ctn" id="echartCtn"></div>
            <div class="data-ctn">
                <div class="search-ctn">
                    <div class="search-ctn-right">
                        <div class="search-name">时间</div>
                        <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                    </div>
                </div>
                <div class="table-ctn">
                    <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border>
                        <el-table-column show-overflow-tooltip prop="CreateTime" label="日期"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="UName" label="推荐客户名称"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="SName" label="推荐人"></el-table-column>
                    </el-table>
                </div>
                <div class="pagination-ctn">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="searchData.page"
                        :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                        :page-size="searchData.limit"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="tableDataLength"
                    ></el-pagination>
                </div>
            </div>
            <el-dialog :close-on-click-modal="false" width="800px" title="推荐收益规则" :visible.sync="dialogShow" append-to-body>
                <div class="dialog-content">
                    <el-table :header-cell-style="{ background: '#F2F6FC' }" border :data="mapData.DiscountList" style="width: 100%">
                        <el-table-column show-overflow-tooltip prop="RecCount" label="推荐人数"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Discount" label="享受折扣"></el-table-column>
                    </el-table>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="closeDialog">关 闭</el-button>
                </span>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="创建时间" :visible.sync="timeVisible" width="800px">
                <div class="dialog-content" v-if="timeVisible">
                    <timePicker @timerSearch="timerSearch" :start="this.searchData.BeginDate" :end="this.searchData.EndDate"></timePicker>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import timePicker from '@/components/common/timePicker';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    components: {
        timePicker,
        breadcrumb
    },
    name: '',
    data() {
        return {
            timeVisible: false,
            dialogShow: false,
            mapData: {},
            mapDate: [],
            mapValue: [],
            searchData: {
                EntpId: this.$util.getLocalStorage('userMsg').EntpId,
                BeginDate: '',
                EndDate: '',
                limit: 15,
                page: 1,
                key: null
            },
            tableData: [],
            tableDataLength: 0
        };
    },
    mounted() {
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.getReCommendCount();
        this.getTableData();
    },
    methods: {
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.BeginDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        resetSearch() {
            this.searchData = {
                EntpId: this.searchData.EntpId,
                BeginDate: '',
                EndDate: '',
                limit: this.commonPageSize,
                page: 1,
                key: null
            };
        },
        closeDialog() {
            this.dialogShow = false;
        },
        showJtgz() {
            this.dialogShow = true;
        },
        //获取推荐列表
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/RevenueManagement/GetRecommendationList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {});
        },
        // 获取本周推荐统计图表
        getReCommendCount() {
            this.$util
                .axiosGet({
                    url: '/api/RevenueManagement/GetCurrentWeekRecommendationStatistics',
                    data: {
                        EntpId: this.searchData.EntpId
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.mapDate = [];
                    this.mapValue = [];
                    let data = res.data;
                    this.mapData = data;
                    let _mapData = data.StatisticsList;
                    for (let i = 0; i < _mapData.length; i++) {
                        this.mapDate.push(_mapData[i].WeekName);
                        this.mapValue.push(_mapData[i].Count);
                    }
                    this.initEchart();
                })
                .catch(() => {});
        },
        initEchart() {
            // 基于准备好的dom，初始化echarts实例
            let myChart = this.$echarts.init(document.getElementById('echartCtn'));
            // 绘制图表
            myChart.setOption({
                title: {
                    text: '推荐趋势'
                },
                tooltip: {
                    trigger: 'axis'
                },
                legend: {
                    data: ['人数']
                },
                toolbox: {
                    show: true,
                    feature: {
                        dataZoom: {
                            yAxisIndex: 'none'
                        },
                        dataView: { readOnly: false },
                        magicType: { type: ['line', 'bar'] },
                        restore: {},
                        saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.mapDate
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: '{value}'
                    }
                },
                series: [
                    {
                        name: '推荐人数',
                        type: 'line',
                        data: this.mapValue,
                        markPoint: {
                            data: [
                                { type: 'max', name: '最大值' },
                                { type: 'min', name: '最小值' }
                            ]
                        },
                        markLine: {
                            data: [{ type: 'average', name: '平均值' }]
                        }
                    }
                ]
            });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        }
    }
};
</script>
<style lang="less" scoped>
.jtgz {
    cursor: pointer;
    border: 1px solid @theme;
    color: @theme;
    border-radius: 5px;
    font-size: @font-xxs;
    padding: 2px;
}
.recommend-main {
    display: flex;
    flex-grow: 1;
}
.echart-ctn {
    width: 50%;
    margin-top: 20px;
    height: 500px;
    padding-right: 20px;
}
.data-ctn {
    display: flex;
    flex-direction: column;
    width: 50%;
}
</style>
